import { FormEvent, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { loginRequest } from '../features/auth/authSlice';
import { BTN_PRIMARY, BTN_PRIMARY_STYLE, FIELD, FIELD_STYLE, LABEL } from '../lib/ui';

export default function LoginPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error, token } = useAppSelector((s) => s.auth);
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (token) navigate('/', { replace: true });
  }, [token, navigate]);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(loginRequest({ email: email.trim(), password }));
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center px-6"
      style={{ background: 'radial-gradient(ellipse at 30% 20%, rgba(232,0,122,0.45), transparent 50%), linear-gradient(145deg, #1a000f 0%, #7a0038 45%, #d6006e 100%)' }}
    >
      <div className="mz-fade-up w-full max-w-[400px] rounded-2xl bg-white/95 p-7 shadow-[0_24px_60px_rgba(212,0,106,0.25)]">
        <div className="mb-5 flex items-center gap-3">
          <BrandLogo size={36} />
          <div>
            <p className="text-lg font-black tracking-tight text-[#6b0030]">Micus Support</p>
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#d6006e]">AI quality & cost desk</p>
          </div>
        </div>
        <p className="mb-4 text-sm text-[#b0708f]">Monitor AI accuracy, spend per company and every failure across the rating pipeline. Micus team only.</p>
        {params.get('expired') === '1' && !error && (
          <p className="mb-3 rounded-xl bg-[#fdf2f8] px-3 py-2 text-sm text-[#9d0050]">Your session expired. Sign in again.</p>
        )}
        {error && <p className="mb-3 rounded-xl border border-[#fecdd3] bg-[#fff1f2] px-3 py-2 text-sm text-[#be123c]">{error}</p>}
        <form onSubmit={onSubmit} className="space-y-3.5">
          <div>
            <label className={LABEL}>Email</label>
            <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={FIELD} style={FIELD_STYLE} placeholder="you@micusify.com" data-testid="login-email" />
          </div>
          <div>
            <label className={LABEL}>Password</label>
            <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={FIELD} style={FIELD_STYLE} placeholder="••••••••" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className={`${BTN_PRIMARY} w-full`} style={BTN_PRIMARY_STYLE} data-testid="login-submit">
            {loading ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>
      </div>
    </div>
  );
}
